import { render } from "./SoftProgress.vue?vue&type=template&id=f40b4fbc"
import script from "./SoftProgress.vue?vue&type=script&lang=js"
export * from "./SoftProgress.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__